import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import _ from 'lodash';
import cx from 'bem-classnames';
import { getElementType, getUnhandledProps } from 'components/lib';

import GridItem from '../Grid/GridItem';
import { useLocation, useNavigate } from 'react-router-dom';

const PlaylistsItem = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const { className, item} = props;

  const { pathname: pathnameProp } = location;
  const pathname = _.replace(pathnameProp, 'browse', `playlist/${item.id}`);

  const classes = cx({ name: 'm-playlists__item' }, props, className);

  const ElementType = getElementType(PlaylistsItem, props);
  const rest = getUnhandledProps(PlaylistsItem, props);
  const imgPlaceholder =
    'data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6CAQAAAAi5ZK2AAABcklEQVR42u3RAQ0AAAgDIJ/EqFa3hptQgfQUz0S6dKQjHelIRzrSkY50pCMd6UhHOtKRjnTpSEc60pGOdKQjHelIRzrSkY50pCMd6dKRjnSkIx3pSEc60pGOdKQjHelIRzrSpSMd6UhHOtKRjnSkIx3pSEc60pGOdKRLRzrSkY50pCMd6UhHOtKRjnSkIx3pSJcuXTrSkY50pCMd6UhHOtKRjnSkIx3pSEe6dKQjHelIRzrSkY50pCMd6UhHOtKRjnTpSEc60pGOdKQjHelIRzrSkY50pCMd6dKRjnSkIx3pSEc60pGOdKQjHelIRzrSpSMd6UhHOtKRjnSkIx3pSEc60pGOdKRLly4d6UhHOtKRjnSkIx3pSEc60pGOdKQjXTrSkY50pCMd6UhHOtKRjnSkIx3pSEe6dKQjHelIRzrSkY50pCMd6UhHOtKRjnTpSEc60pGOdKQjHelIRzrSkY50pCMd6dKRjnSkIx3pSEc6NyzdBJtHhLFcFAAAAABJRU5ErkJggg==';
  const content = (
    <ElementType
      {...rest}
      className={classes}
      onClick={() => navigate(pathname)}
    >
      <img src={item.image} alt="" className="m-playlists__item--main" />
      <img src={imgPlaceholder} alt="" className="m-playlists__item--ph" />
    </ElementType>
  );
  //

  return <GridItem item={content} className="col-xs-4 col-sm-3 col-lg-2" />;
};

PlaylistsItem.handledProps = ['item', 'location', 'onRedirectPlaylist'];

PlaylistsItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape(),
};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(PlaylistsItem);
